import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a9a3b506"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a9a3b506&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchSchoolBanner: require('/app/nuxt/components/SearchSchoolBanner.vue').default,WrapComponents: require('/app/nuxt/components/WrapComponents.vue').default,Tuition: require('/app/nuxt/components/Tuition.vue').default,Benchmark: require('/app/nuxt/components/Benchmark.vue').default})
